export class BupError extends Error {
  constructor ({ cause, code, message } = {}) {
    super(message || code)
    this.code = code
    this.name = this.constructor.name
    this.cause = cause
  }
}
